const URL = "https://aptideasolutions.com/redelectro/api";
const api = {
  PRODUCTS_API: URL + "/category",
};
export default api;
